/* SuperHoodie redesign – collection page: submit the sort form when the selection changes;
   cushions: the style chips above the grid hide the cards of the other styles. */
(function () {
  document.querySelectorAll('form[data-sh-sort] select[name="sort_by"]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.form.submit();
    });
  });

  document.querySelectorAll('[data-sh-kfilter]').forEach(function (group) {
    var btns = group.querySelectorAll('[data-kstil]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var want = btn.getAttribute('data-kstil');
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        document.querySelectorAll('[data-sh-grid] > .sh-coll__item[data-kstil]').forEach(function (li) {
          li.hidden = !!want && li.getAttribute('data-kstil') !== want;
        });
      });
    });
  });
})();
